<template>
    <div class="box pa-1 grey--text text--darken-1 number text-no-wrap">
        {{ displayValue }}
    </div>
</template>

<script>

export default {

    components: {},

    props: {
        value: {
            type: Number | null,
            required: true,
            default: null
        },
        animate: {
            type: Boolean,
            required: false,
            default: true,
        },
    },

    data() {
        return {
            boxValue: null,
            animationRunning: false,
            step: 1,
            diff: null,
            timer: null,
        }
    },

    computed: {
        displayValue() {
            if (this.boxValue !== null) {
                return this.boxValue.toLocaleString();
            } else {
                return 0;
            }
        },
    },

    watch: {
        value(newCount, currentCount) {

            currentCount = parseInt(currentCount);

            this.boxValue = currentCount;
            this.animateStart(newCount, currentCount);
        },
    },

    methods: {

        animateStart(newCount, currentCount) {

            newCount = parseInt(newCount);
            currentCount = parseInt(currentCount);

            // Prevent double animation
            if (!this.animationRunning && currentCount !== newCount) {

                this.animationRunning = true;

                // Count up
                if (newCount > currentCount) {
                    this.diff = newCount - currentCount;
                    this.step = Math.floor(this.diff / 100);
                } else {
                    this.diff = currentCount - newCount;
                    this.step = Math.floor(this.diff / 100) * -1;
                }

                this.timer = setInterval(() => {
                    this.boxValue += this.step;
                }, 10);

                setTimeout(() => {
                    clearInterval(this.timer);
                    this.boxValue = newCount;
                    this.animationRunning = false;
                }, 1000);
            }
        },
    },

    // Seed initial value
    mounted() {
        if (this.animate) {
            this.boxValue = 0;
            if (this.value !== null) this.animateStart(this.value, 0);
        } else {
            if (this.value !== null) {
                this.boxValue = this.value;
            } else {
                this.boxValue = 0;
            }
        }
    }
}
</script>

<style scoped>

.number {
    font-size: 2.0em;
}

.box {
    line-height: 40px;
    height: 50px;
    vertical-align: middle;
}
</style>